import { render } from "./linkbutton.vue?vue&type=template&id=2bf9d201&scoped=true"
import script from "./linkbutton.vue?vue&type=script&lang=js"
export * from "./linkbutton.vue?vue&type=script&lang=js"

import "./linkbutton.vue?vue&type=style&index=0&id=2bf9d201&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf9d201"]])

export default __exports__